import React from "react";
import { Grid } from "@mui/material";
import FormTemplateWrapper from "../../../v3/sharedComponents/forms/FormTemplateWrapper";

const UserAgreementDetail = (props) => {
  const { formId, onSave } = props;

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid
        item
        xs={12}
        style={{ width: "100%", maxWidth: "800px", marginTop: "40px" }}
      >
        <FormTemplateWrapper formId={formId} onComplete={onSave} />
      </Grid>
    </Grid>
  );
};
export default UserAgreementDetail;
